export const LOCALE_CONFIG = {
  es: {
    hreflang: 'es-ES',
    label: 'ES',
    nativeName: 'Español',
    indexable: true,
  },
  en: {
    hreflang: 'en-US',
    label: 'EN',
    nativeName: 'English',
    indexable: true,
  },
  fr: {
    hreflang: 'fr-FR',
    label: 'FR',
    nativeName: 'Français',
    indexable: false,
  },
  de: {
    hreflang: 'de-DE',
    label: 'DE',
    nativeName: 'Deutsch',
    indexable: false,
  },
  it: {
    hreflang: 'it-IT',
    label: 'IT',
    nativeName: 'Italiano',
    indexable: false,
  },
  pt: {
    hreflang: 'pt-PT',
    label: 'PT',
    nativeName: 'Português',
    indexable: false,
  },
  nl: {
    hreflang: 'nl-NL',
    label: 'NL',
    nativeName: 'Nederlands',
    indexable: false,
  },
  ro: {
    hreflang: 'ro-RO',
    label: 'RO',
    nativeName: 'Română',
    indexable: false,
  },
  ar: {
    hreflang: 'ar',
    label: 'AR',
    nativeName: 'العربية',
    indexable: false,
  },
} as const;

export type SiteLocale = keyof typeof LOCALE_CONFIG;

export const DEFAULT_LOCALE = 'es' as const;
export const PRIMARY_FOREIGN_LOCALE = 'en' as const;

export const SUPPORTED_LOCALES = Object.keys(LOCALE_CONFIG) as SiteLocale[];
export const NON_DEFAULT_LOCALES = SUPPORTED_LOCALES.filter(
  (locale): locale is Exclude<SiteLocale, typeof DEFAULT_LOCALE> => locale !== DEFAULT_LOCALE,
);

export const HREFLANG_BY_LOCALE: Record<SiteLocale, string> = Object.fromEntries(
  SUPPORTED_LOCALES.map((locale) => [locale, LOCALE_CONFIG[locale].hreflang]),
) as Record<SiteLocale, string>;

export function isSupportedLocale(value: string): value is SiteLocale {
  return SUPPORTED_LOCALES.includes(value as SiteLocale);
}

export function normalizeLocale(value: string | null | undefined): SiteLocale {
  if (!value) return DEFAULT_LOCALE;
  const normalized = value.trim().toLowerCase();
  return isSupportedLocale(normalized) ? normalized : DEFAULT_LOCALE;
}

export function isDefaultLocale(locale: SiteLocale): boolean {
  return locale === DEFAULT_LOCALE;
}

export function isLocaleIndexable(locale: SiteLocale): boolean {
  return LOCALE_CONFIG[locale].indexable;
}

export function getLocaleHomePath(locale: SiteLocale): string {
  return locale === DEFAULT_LOCALE ? '/' : `/${locale}`;
}
